<div class="navigation-container">
  @for (letter of alphabetLetters; track letter) {
    <mat-button-toggle-group>
      <mat-button-toggle value="{{letter}}" (change)="select(letter)" class="selectionButton">{{letter}}</mat-button-toggle>
    </mat-button-toggle-group>
  }
</div>
